import { css } from "@emotion/react";

export const centerSubmitButtonCss = css`
  height: 35px;
  min-width: 35px;
  width: auto;
  margin: 0 auto;
`;
export const labellessButtonCss = css`
  height: 35px;
  width: 35px;
`;

export const hwrInfoButtonCss = css`
  margin-bottom: 5px;
  margin-right: 5px;
`;
